export const RailbarContainer = ({
  id = "rail-bar-header",
}: {
  id?: string;
}) => <div id={id} />;
